export default __webpack_public_path__ + "static/media/104_trashotic.051af22e.png";